var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNews(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    width: "1em",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M257.443 751.523L587.475 750.783",
    fill: "none",
    opacity: 1,
    stroke: "#565656",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 17.4388
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M837.725 798.366L837.725 145.34C837.725 118.956 817.095 97.5679 791.648 97.5679L243.802 97.5679C218.354 97.5679 197.725 118.956 197.725 145.34L197.725 868.446C197.725 908.158 223.725 938.526 257.725 938.526L717.725 938.526C783.725 938.526 837.725 875.454 837.725 798.366Z",
    fill: "#ffd1c1",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.767 234.863L525.288 234.863C530.322 234.863 534.402 237.997 534.402 241.863L534.402 446.063C534.402 449.929 530.322 453.063 525.288 453.063L266.767 453.063C261.734 453.063 257.653 449.929 257.653 446.063L257.653 241.863C257.653 237.997 261.734 234.863 266.767 234.863Z",
    fill: "#82c1ff",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.894 568.824L766.7 568.824C769.695 568.824 772.123 571.958 772.123 575.824L772.123 780.025C772.123 783.891 769.695 787.025 766.7 787.025L612.894 787.025C609.899 787.025 607.471 783.891 607.471 780.025L607.471 575.824C607.471 571.958 609.899 568.824 612.894 568.824Z",
    fill: "#82c1ff",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.816 257.132L784.156 257.57",
    fill: "none",
    opacity: 1,
    stroke: "#565656",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 17.4388
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.325 507.136L766.571 507.575",
    fill: "none",
    opacity: 1,
    stroke: "#565656",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 17.4388
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.816 317.245L784.156 319",
    fill: "none",
    opacity: 1,
    stroke: "#565656",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 17.4388
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.325 571.249L571.237 573.286",
    fill: "none",
    opacity: 1,
    stroke: "#565656",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 17.4388
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.816 378.236L784.156 377.358",
    fill: "none",
    opacity: 1,
    stroke: "#565656",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 17.4388
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.325 632.452L571.654 631.362",
    fill: "none",
    opacity: 1,
    stroke: "#565656",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 17.4388
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.816 436.594L784.156 435.716",
    fill: "none",
    opacity: 1,
    stroke: "#565656",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 17.4388
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.325 690.46L573.65 689.72",
    fill: "none",
    opacity: 1,
    stroke: "#565656",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 17.4388
  })), /*#__PURE__*/React.createElement("path", {
    d: "M419.47 132.929L419.47 132.929C432.172 132.929 442.47 147.48 442.47 165.429L442.47 165.429C442.47 183.378 432.172 197.929 419.47 197.929L419.47 197.929C406.767 197.929 396.47 183.378 396.47 165.429L396.47 165.429C396.47 147.48 406.767 132.929 419.47 132.929Z",
    fill: "none",
    opacity: 1,
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 17.4388
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.893 938.526C702.9 938.526 700.903 938.526 696.91 938.526L217.692 938.526C151.8 938.526 97.8879 870.32 97.8879 786.958L97.8879 757.517C97.8879 745.874 107.327 736.435 118.97 736.435L575.99 736.435C587.634 736.435 597.073 745.874 597.073 757.517L597.073 786.958C597.073 865.268 644.994 930.948 706.893 938.526Z",
    fill: "#ff915a",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.47 132.929L488.47 132.929C501.172 132.929 511.47 147.48 511.47 165.429L511.47 165.429C511.47 183.378 501.172 197.929 488.47 197.929L488.47 197.929C475.767 197.929 465.47 183.378 465.47 165.429L465.47 165.429C465.47 147.48 475.767 132.929 488.47 132.929Z",
    fill: "none",
    opacity: 1,
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 17.4388
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.47 132.929L557.47 132.929C570.172 132.929 580.47 147.48 580.47 165.429L580.47 165.429C580.47 183.378 570.172 197.929 557.47 197.929L557.47 197.929C544.767 197.929 534.47 183.378 534.47 165.429L534.47 165.429C534.47 147.48 544.767 132.929 557.47 132.929Z",
    fill: "none",
    opacity: 1,
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 17.4388
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.493 132.929L631.493 132.929C644.196 132.929 654.493 147.48 654.493 165.429L654.493 165.429C654.493 183.378 644.196 197.929 631.493 197.929L631.493 197.929C618.791 197.929 608.493 183.378 608.493 165.429L608.493 165.429C608.493 147.48 618.791 132.929 631.493 132.929Z",
    fill: "none",
    opacity: 1,
    stroke: "#4f4f4f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 17.4388
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNews);
export default __webpack_public_path__ + "static/media/News.796d7cd29d5b9b91beb396225d586eca.svg";
export { ForwardRef as ReactComponent };